import { Suspense } from "react";
import { Navigate, useOutlet } from "react-router-dom";
import { usePromiseTracker } from "react-promise-tracker";
import RoutesString from "./routesString";
import LoggedInLayout from "../components/layout/logged-in-layout/LoggedInLayout";
import Spinner from "../components/common/spinner/Spinner";
import useAuth from "@/hooks/useAuth";
import { Center, Loader } from "@mantine/core";

const PrivateRoute = () => {
  const Layout = LoggedInLayout;
  const { isAuthenticated, isFetching } = useAuth();
  const outlet = useOutlet();
  const { promiseInProgress } = usePromiseTracker();

  // Chỉ chặn bằng loader khi CHƯA xác thực (lần đầu / reload). Khi đã đăng nhập
  // (isAuthenticated từ Redux), không chặn theo isFetching — tránh vòng lặp
  // remount vô hạn khi getUserProfile refetch/fail (endpoint BE thiếu trên môi trường này).
  if (isFetching && !isAuthenticated) {
    return (
      <Center w="100%" h="100vh">
        <Loader size="xl" variant="bars" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={{
          pathname: RoutesString.PreLogin,
        }}
      />
    );
  }

  if (isAuthenticated) {
    return (
      <Layout>
        <Suspense fallback={<Spinner />}>
          {promiseInProgress && <Spinner />}
          {outlet}
        </Suspense>
      </Layout>
    );
  }

  return <Spinner />;
};

export default PrivateRoute;
